import { defineMessages } from 'react-intl';

export default defineMessages({
    sNo: {
        id: 'ml.quoteandbind.seperateStructureExclusion.sNo',
        defaultMessage: 'S No.'
    },
    address: {
        id: 'ml.quoteandbind.seperateStructureExclusion.address',
        defaultMessage: 'Address'
    },
    description: {
        id: 'ml.quoteandbind.seperateStructureExclusion.description',
        defaultMessage: 'Description of Excluded Structure(s)'
    },
    action: {
        id: 'ml.quoteandbind.seperateStructureExclusion.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.seperateStructureExclusion.modalTitle',
        defaultMessage: 'Add Excluded Separate Structures'
    },
    addressLine1: {
        id: 'ml.quoteandbind.seperateStructureExclusion.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.seperateStructureExclusion.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.seperateStructureExclusion.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.seperateStructureExclusion.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.seperateStructureExclusion.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.seperateStructureExclusion.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.seperateStructureExclusion.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.seperateStructureExclusion.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.seperateStructureExclusion.continueBtn',
        defaultMessage: 'Continue'
    },
});
